// import _ from 'lodash';
import update from 'immutability-helper';
import reduceReducers from 'reduce-reducers';
import * as cookie from 'app/utils/cookie';
import * as routePath from 'app/utils/routePath';
import I18n from 'app/common/i18n';

import * as api from 'app/client/api';
import {validateSchema} from 'app/common/validations';
import {showAppBusy, loadApp, handleAppError} from './app';
import {history} from 'store';

const initialState = {
  email: '',
  password: '',
  errors: {},
  hasEmailSent: false,
};

const SCHEMA_ID = 'dk-admin/signIn'

const UPDATE_EMAIL = 'login/UPDATE_EMAIL';
const UPDATE_PASSWORD = 'login/UPDATE_PASSWORD';
const LOGIN_FAILED = 'login/LOGIN_FAILED';
const SUCCESS = 'login/SUCCESS';
const UPDATE_EMAIL_SENT_FLAG = 'login/UPDATE_EMAIL_SENT_FLAG';
const RECOVER_PASSWORD_FAILED = 'RECOVER_PASSWORD_FAILED';

export function updateEmailSentFlag(payload) {
  return { type: UPDATE_EMAIL_SENT_FLAG, payload }
}

export function updateEmail(payload) {
  return { type: UPDATE_EMAIL, payload }
}

export function updatePassword(payload) {
  return { type: UPDATE_PASSWORD, payload }
}

export function loginFailed(payload) {
  return { type: LOGIN_FAILED, payload }
}

export function recoverPasswordFailed(payload) {
  return { type: RECOVER_PASSWORD_FAILED, payload }
}

export function loginSuccessful() {
  return { type: SUCCESS }
}

export function _logoutUser() {
  return { type : 'USER_LOGOUT'}
}

export function  loginUser() {
  return async (dispatch, getState) => {
    dispatch(showAppBusy(true));
    let loginState = getState().login;
    let credentials = {
      email: loginState.email.trim(),
      password: loginState.password
    };
    try {
      await api.login(credentials);
      cookie.set(cookie.KEY_LOGIN_TOKEN, true);
      dispatch(loginSuccessful());
      dispatch(loadApp());
      dispatch(showAppBusy(false));
      history.push(routePath.dashboardRoute);
    } catch(exception)  {
      let stateErrorHandler = (errorResponse) => {
        let errorMessage = (errorResponse.data && errorResponse.data.message) ? errorResponse.data.message : I18n.t('errors.unexpected');
        dispatch(loginFailed(errorMessage));
      };
      dispatch(handleAppError(exception, I18n.t('errors.unexpected'), stateErrorHandler));
      dispatch(showAppBusy(false));
    }
  }
}

export function  logoutUser() {
  return async (dispatch, getState) => {
    dispatch(showAppBusy(true));
    try {
      await api.logout();
      dispatch(showAppBusy(false));
      cookie.remove(cookie.KEY_LOGIN_TOKEN);
      dispatch(_logoutUser());
      history.push(routePath.rootRoute);
    } catch(exception)  {
      dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
      dispatch(showAppBusy(false));
    }
  }
}


export function  initiateForgetPassword() {
  return async (dispatch, getState) => {
    dispatch(showAppBusy(true));
    let email = getState().login.email.trim();
    try {
      let response = await api.forgetPassword({email});
      dispatch(updateEmailSentFlag(true));
      dispatch(showAppBusy(false));
    } catch(exception)  {
      let stateErrorHandler = (errorResponse) => {
        let errorMessage = (errorResponse.data && errorResponse.data.message) ? errorResponse.data.message : I18n.t('errors.unexpected');
        dispatch(recoverPasswordFailed(errorMessage));
      };
      dispatch(handleAppError(exception, I18n.t('errors.unexpected'), stateErrorHandler));
      dispatch(showAppBusy(false));
    }
  }
}



function validator(state = initialState, action)  {
  let {type} = action;
  switch(type)  {
    case UPDATE_EMAIL:
    case UPDATE_PASSWORD:
      let validationErrors = validateSchema(state, SCHEMA_ID);
      return update(state, { errors: { validation: {$set: validationErrors }}});

    default:
      return state;
  }
}

function reducer(state = initialState, action) {
  let { payload, type } = action;
  switch(type)  {
    case UPDATE_EMAIL:
      return update(state, { email: { $set: payload }});

    case UPDATE_PASSWORD:
      return update(state, { password: { $set: payload }});

    case LOGIN_FAILED:
      return update(state, { errors: { login: { $set: payload }}});

    case RECOVER_PASSWORD_FAILED:
      return update(state, { errors: { recoverPassword: { $set: payload }}});

    case SUCCESS:
      return update(state, { errors: { login: { $set: null }}});

    case UPDATE_EMAIL_SENT_FLAG:
      return update(state, {hasEmailSent: { $set: payload }});

    default:
      return state;
  }
}

export default reduceReducers(
  reducer,
  validator,
)



// WEBPACK FOOTER //
// ./src/reducers/login.js